import type {
  ProblemTheme,
  ProblemThemeList,
} from "@shared/types/problem-theme";
import { api } from "./client";

function buildQuery(category?: string): string {
  if (!category) return "";
  const params = new URLSearchParams({ category });
  return `?${params.toString()}`;
}

export const problemThemesApi = {
  list(category?: string): Promise<ProblemThemeList> {
    return api.get<ProblemThemeList>(
      `/api/problem-themes${buildQuery(category)}`,
    );
  },
  create(category: string, name: string): Promise<ProblemTheme> {
    return api.post<ProblemTheme>("/api/problem-themes", { category, name });
  },
};
